import React from 'react';
import classes from './HeaderComponent.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setIsUploadingSomeChat, setSelectedKeys } from 'store/slices/windowStateSlice';
import { useNavigate } from 'react-router';
import RowLoader from 'components/Sceletons/RowLoader';
import { fetchChatHistory, fetchSetSelectedChat } from 'store/reducers/chatCreator';
import NameAvatar from './NameAvatar';
import NameAndDescription from './NameAndDescription';
import ControlButtons from './ControlButtons';
import SegmentSwitch from './SegmentSwitch';
import { serializeFiltersToUrl } from 'helpers/documentFiltersUrl';

type NavigationProps = {
  isAvailableUploading: boolean;
}

function Navigation({isAvailableUploading}: NavigationProps) {  
  const { dataRoom, isLoadingRoom } = useAppSelector((state) => state.dataRoom);
  const { isLoadingUserData, available_rooms, isLoadingRooms } = useAppSelector((store) => store.userData);
  const { roomAllChats } = useAppSelector((state) => state.chat);
  const { viewType, selectedDocument, appliedFilters } = useAppSelector((state) => state.documents);

  const isLoadinInformation = isLoadingRoom || isLoadingUserData || isLoadingRooms;
  const notLoadedFile = viewType === 'Document' && !selectedDocument;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onSegmentCahnge = async (value: string | number) => {
    const selectedValue = value as string;
    dispatch(setSelectedKeys([selectedValue]));
    if (selectedValue === 'documents') {
      const filterParams = serializeFiltersToUrl(new URLSearchParams(), appliedFilters).toString();
      const filterQuery = filterParams ? `?${filterParams}` : '';
      if (dataRoom?.id) navigate(`/room/${dataRoom.custom_url || dataRoom?.id}/documents${filterQuery}`);
      else if (available_rooms[0]?.id)
        navigate(`/room/${available_rooms[0]?.custom_url || available_rooms[0]?.id}/documents${filterQuery}`);
      else navigate(`/noAvailablesRooms`);
    } else if (selectedValue === 'chat') {
      navigate(`/room/${dataRoom?.custom_url || dataRoom?.id}/${selectedValue}`);
      const mainChat = roomAllChats.find(chat => chat.entity_type === 1);
      if (mainChat) {
        dispatch(setIsUploadingSomeChat(true));
        dispatch(fetchSetSelectedChat(mainChat));
        await dispatch(fetchChatHistory({ chat_id: mainChat.id, room_id: mainChat?.room_id! }));
        dispatch(setIsUploadingSomeChat(false));
      }
    } else {
      if (dataRoom?.id) navigate(`/room/${dataRoom.custom_url || dataRoom?.id}/${selectedValue}`);
      else if (available_rooms[0]?.id)
        navigate(`/room/${available_rooms[0]?.custom_url || available_rooms[0]?.id}/${selectedValue}`);
    }
  };

  const isPrivateRoom = dataRoom?.id === '143d9fd4-96b7-46e8-819f-9515a04eaff9' // не трогать
  return (
    <div className={classes.navigationWrap}>
      <div className={classes.navigation}>
        {(isLoadinInformation || notLoadedFile)
          ? <RowLoader width='200px' padding='2px 0 0 0' height='27px' />
          : <div className={classes.roomInfo}>
            <NameAvatar name={dataRoom?.name}/>
            <NameAndDescription />
          </div>
        }

        {isPrivateRoom && <a rel='noreferrer' target='_blank' href='https://usquestlaw.com' className={classes.navigation_logo} />}

        <ControlButtons
          onSegmentCahnge={onSegmentCahnge}
          isAvailableUploading={isAvailableUploading}
        />

      </div>
      <SegmentSwitch onSegmentCahnge={onSegmentCahnge} />
    </div>
  );
}

export default Navigation;
